import { environment } from './../../../../../environment/environment';
import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { ChangeDetectorRef, Component, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastMessage } from './../../../../core/models/chapitreeval';
import {
  sendEvaluation,
  serverError,
} from './../../../../core/models/messages';
import { EsnEvaluationService } from './../../../../core/services/esn-evaluation/esn-evaluation.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-details-eval-rec',
  templateUrl: './details-eval-rec.component.html',
  styleUrls: ['./details-eval-rec.component.css'],
})
export class DetailsEvalRecComponent {
  id = this.activatedRoute.snapshot.params['id'];
  evaluation: any;
  private unsubscribeAll: Subject<void> = new Subject();
  isCancelDisabled: boolean = true;
  isSendDisabled: boolean = true;
  modalRef?: BsModalRef;
  file: any;
  fileError: string = '';
  fileExtention: string = '';
  evaluationDetailsArray: any[] = [];
  starsArray: any[] = [];
  evaluationDetais: any;
  isDropdownOpen = false;
  currentUser: any;
  first_name: any;
  last_name: any;
  user: any;
  logo: any;
  type: any;
  nomconsultant: any;
  name: any;
  lastnameconsultant: any;
  urlimage: string = environment.baseUrlGalery;
  ratings: any = [];
  starRatings: number[] = [1, 2, 3, 4, 5];
  evaluationData: any;
  comments: { [key: number]: { [key: number]: string } } = {};
  selectedStars: any = [];
  url: string = environment.baseUrl + '/api';
  editReviewForm!: FormGroup;
  selectedRating: number = 0;
  toastMessages2: ToastMessage = {
    success: 'Modification de votre compte rendu avec succès',
    error: 'Une compte  avec ce nom existe déjà',
  };
  toolbarOptions = [
    ['bold', 'italic', 'underline'], // toggled buttons
    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ color: [] }, { background: [] }], // outdent/indent
    ['clean'], // remove formatting button
  ];
  evaluation_send_id!: string;
  isAdded: boolean = false;
  constructor(
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private evalService: EsnEvaluationService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private localStorageService: LocalStorageService,
    private ajoutcompterendu: EsnEvaluationService,
    private deletepv: EsnEvaluationService,
    private modalService: BsModalService,
    private cdRef: ChangeDetectorRef,
  ) {}
  ngOnInit() {
    this.getevaluationById();
    console.log('detail', this.getevaluationById());
    this.getUser();
    this.editReviewForm = this.reviewForm();
    this.editReviewForm.get('stars')?.valueChanges.subscribe((rating) => {
      this.selectedRating = rating;
    });
  }


  
  reviewForm(data?: any) {
    return this.formBuilder.group({
      id: [data.id, [Validators.required]],
      question: [data.question, [Validators.required]],
      stars: [data.stars, [Validators.required]],
      comment: [data.comment, [Validators.required]],
    });
  }
  groupedEvaluationDetails: any[] = [];
  /* get evaluation details */
  getevaluationById() {
    this.spinner.show();
    this.evalService.getevaluationreceivebyid(this.id).subscribe({
        next: (res: any) => {
            console.log(res);
            this.spinner.hide();
            this.evaluation = res.data;
            console.log('detail evaluation', this.evaluation);
            if(this.evaluation.evaluation===null)
              {
               this.evaluationDetais=res.data.default_evaluation_company
    
              }
              if(this.evaluation.default_evaluation_company===null)
                {
                 this.evaluationDetais=res.data.evaluation
      
                }
          
            this.evaluationDetailsArray = this.evaluationDetais?.question_evaluation || [];
            
            // Regrouper les questions par module
            const questionsByModule = new Map<number, any[]>();

            this.evaluationDetailsArray.forEach((item) => {
                const moduleId = item.chapter_eval_id;
                if (!questionsByModule.has(moduleId)) {
                    questionsByModule.set(moduleId, []);
                }
                questionsByModule.get(moduleId)?.push(item);
            });

            this.groupedEvaluationDetails = Array.from(questionsByModule.entries());
            
            // Pour déboguer
            console.log('groupedEvaluationDetails', this.groupedEvaluationDetails);
            
        },
        error: (error) => {
            this.spinner.hide();
            console.log('error detail', error);
        },
    });
}


  extractTypeResponses(): string[] {
    const typeResponses: string[] = [];

    if (this.evaluationDetais && this.evaluationDetais.question_evaluation) {
      const questions = this.evaluationDetais.question_evaluation;

      for (const questionId in questions) {
        if (questions.hasOwnProperty(questionId)) {
          const question = questions[questionId];
          if (question && question.typeResponse) {
            typeResponses.push(question.typeResponse);
          }
        }
      }
    }

    return typeResponses;
  }

  setRating(questionId: any, index?: any, stars?: number) {
    this.starsArray[index] = stars;
    let id = this.evaluation.id;
    this.ratings.push({
      question_evaluation_id: questionId,
      evaluation_send_id: id,
      stars: stars,
      comment: this.comments[questionId],
    });
    let data = {
      responses: this.ratings,
    };
    this.selectedStars.push({
      id: questionId,
      stars: stars,
    });
    this.evaluationData = data;
    console.log('evaluationData', this.evaluationData);
  }

  /////////ajouter un compte rendu //////////////////////////////////////////////////////
  formPV: FormGroup = this.createPVForm();
  // unsubscription

  createPVForm(data?: any) {
    return this.formBuilder.group({
      evaluation_send_id: [''],
      report: [data && data.report,Validators.required],
      esn_id: [this.localStorageService.getData('clientConnectedName')],
    });
  }

  getUser() {
    this.currentUser = this.localStorageService.getData('UserInfo');
    console.log('eeeeeeeeeeeeeeeeeeeeeeeeeeeee', this.currentUser);
    this.first_name = JSON.parse(this.currentUser).company.name;
    console.log('first', this.first_name);
    // this.last_name = JSON.parse(this.currentUser).last_name
    this.logo = JSON.parse(this.currentUser).company.logo;
    this.nomconsultant = JSON.parse(this.currentUser).first_name;
    this.lastnameconsultant = JSON.parse(this.currentUser).last_name;
    this.name = JSON.parse(this.currentUser).company.name;
    this.type = JSON.parse(this.currentUser).company.type;
  }
  createcompterendu() {
    if (this.formPV.invalid) {
      const reportControl = this.formPV.get('report');
      if (reportControl?.hasError('required')) {
        this.toastr.error('Veuillez remplir le champ de rapport avant de soumettre.');
      }
      return;
    }
    this.formPV.get('evaluation_send_id')?.setValue(this.evaluation.evaluation_send.id);
    console.log('evalsent', this.evaluation_send_id);

    this.spinner.show();
    this.ajoutcompterendu
      .ajoutercompterendu(this.formPV.value)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          console.log('res,', res);
          this.spinner.hide();
          this.toastr.success(this.toastMessages2.success);
          this.closeModal();
          this.getevaluationById();
          this.isAdded = true;
        },
        error: (err) => {
          this.spinner.hide();
          if (err?.error?.message?.name) {
            this.toastr.error(this.toastMessages2.error);
          } else {
            this.toastr.error(serverError);
          }
        },
      });
  }
  updatecompterendu() {
    // if (this.formPV.invalid) {
    //   const reportControl = this.formPV.get('report');
    //   if (reportControl?.hasError('required')) {
    //     this.toastr.error('Veuillez remplir le champ de rapport avant de soumettre.');
    //   }
    //   return;
    // }
    this.spinner.show();
    this.formPV.get('evaluation_send_id')?.setValue(this.evaluation_send_id);
    console.log('evalsent', this.evaluation_send_id);


    this.ajoutcompterendu
      .updatecompterendu(this.id,this.formPV.value)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          console.log('res,', res);
          this.spinner.hide();
          this.toastr.success(this.toastMessages2.success);
          this.closeModal();
          this.getevaluationById();
          this.getUser();
          this.isAdded = true;
          this.cdRef.detectChanges();
      
        },
        error: (err) => {
          this.spinner.hide();
          if (err?.error?.message?.name) {
            this.toastr.error(this.toastMessages2.error);
          } else {
            this.toastr.error(serverError);
          }
        },
      });
  }
  closeModal() {
    this.modalRef?.hide();
    this.formPV.reset();
    this.file = null;
    this.fileError = '';
    this.fileExtention = '';
  }
  openModall(template: TemplateRef<any>, data?: any, mode?: string) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });

    if (data) {
      console.log("data",data)
      this.id = data.id;
      // Ajoutez cette ligne
      this.formPV = this.createPVForm(data);
      console.log("formPV",this.formPV)
    }
  }
  deleteevaluation(id: any) {
    if (!this.evaluation?.evaluation_send.pv) {
      this.toastr.error('Aucun compte rendu disponible à supprimer.');
      return;
    }
  
    Swal.fire({
      title: 'Êtes-vous sûr(e) de Supprimer votre Pv ?',
      text: 'Vous ne pourrez pas revenir en arrière !',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Annuler',
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, supprimer !',
    }).then((result) => {
      if (result.isConfirmed) {
        this.deletepv.deletepv(id).subscribe(
          (res: any) => {
            Swal.fire('compte rendu a été supprimé!', 'PV a été supprimé.', 'success');
            this.getevaluationById();
          },
          (error) => {
            if (error.status === 404) {
              this.toastr.warning('PV not found');
            } else {
              this.toastr.error("Une erreur s'est produite lors de la suppression", 'Erreur');
            }
          }
        );
      }
    });
  }
  
  editReviewCandidateForCompany() {
    this.id = this.editReviewForm.get('id')?.value;

    const data = {
      stars: this.editReviewForm.get('stars')?.value,
    };

    console.log('edit evaluation', this.id, data);

    this.deletepv
      .updateEvaluationResponses(this.id, data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          console.log('resss', res);
          if (res.status == 200) {
            this.toastr.success('successEvaluationupdate');
            this.getevaluationById();
            this.closeModal();
          }
        },
        error: (err: any) => {
          if (err.error) {
            // this.toastrService.error(serverError)
          }
        },
      });
  }
  editCommentCandidateForCompany() {
    this.id = this.editReviewForm.get('id')?.value;
    const data = {
      comment: this.editReviewForm.get('comment')?.value,
    };
    console.log('edit evaluation', this.id, data);
    this.deletepv
      .updateEvaluationResponses(this.id, data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          console.log('resss', res);
          if (res.status == 200) {
            this.toastr.success('successEvaluationupdateeeeeee');
            this.getevaluationById();
            
            this.closeModal();
          }
        },
        error: (err: any) => {
          if (err.error) {
            // this.toastrService.error(serverError)
          }
        },
      });
  }

  sendEvaluation() {
    console.log("this.evaluation.pv",this.evaluation.pv)
    if (this.evaluation.evaluation_send.pv === null) {
      this.toastr.error('Veuillez ajouter un compte rendu avant d\'envoyer.');
return;
    }
  
    let data = {
      id: this.evaluation.evaluation_send.pv?.id,
    };
  
    this.spinner.show();
  if(this.evaluation.default_evaluation_company===null){
    this.deletepv
      .sendpv(this.evaluation.evaluation_send.pv?.id,this.evaluation.evaluation.esn_id, data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.toastr.success('Évaluation envoyée avec succès.');
          this.getevaluationById();
          this.spinner.hide();
        },
        error: (err: any) => {
          this.spinner.hide();
          if (err.error) {
            this.toastr.error('Erreur serveur.');
          }
        },
      });
    }
    if(this.evaluation.evaluation===null){
      this.deletepv
        .sendpv(this.evaluation.evaluation_send.pv?.id,this.evaluation.default_evaluation_company.esn_id, data)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.toastr.success('Évaluation envoyée avec succès.');
            this.getevaluationById();
            this.spinner.hide();
          },
          error: (err: any) => {
            this.spinner.hide();
            if (err.error) {
              this.toastr.error('Erreur serveur.');
            }
          },
        });
      }
  }
  
  addEvaluation() {
    console.log('selectedStars', this.selectedStars);
    for (const key in this.comments) {
      if (Object.prototype.hasOwnProperty.call(this.comments, key)) {
        const element = this.comments[key];
        console.log('element', key);
        let id = this.evaluation.id;
        this.ratings.push({
          question_evaluation_id: key,
          evaluation_send_id: id,
          comment: element,
        });
      }
    }
    let data = {
      responses: this.ratings,
    };

    this.spinner.show();

    this.deletepv
      .addEvaluationResponses(data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          if (res.status == 200) {
            this.toastr.success('évaluation a été enregistré avec succés');
            this.getevaluationById();
            // this.isCancelDisabled = false;
            // this.isSendDisabled = false;
          }
          this.spinner.hide();
        },
        error: (err: any) => {
          this.spinner.hide();
          if (err.error) {
            this.toastr.error(serverError);
          }
          // this.isCancelDisabled = true;
          // this.isSendDisabled = true;
        },
      });
  }

  openModal(template?: TemplateRef<any>, idquestion?: any) {
    if (template) {
      this.modalRef = this.modalService.show(template, { backdrop: 'static' });
      this.editReviewForm = this.reviewForm(idquestion);
      this.editReviewForm
        .get('stars')
        ?.setValue(Number(idquestion.response_evaluation[0]?.stars));
      this.editReviewForm
        .get('comment')
        ?.setValue(idquestion.response_evaluation[0]?.comment);
      this.editReviewForm.get('question')?.setValue(idquestion.question);
      this.selectedRating = idquestion.response_evaluation[0]?.stars;
      this.editReviewForm.get('question')?.disable();
      this.editReviewForm
        .get('id')
        ?.setValue(idquestion.response_evaluation[0]?.id);
    } else {
      console.error('Invalid template reference');
    }
  }
}
